function About(){
    return (    <div className="container">
        <div className="section">
            <h2><strong>Who We Are</strong></h2>
            <p>TriStar Engineers and Services is an ISO 9001 and ISO 2015 Certified Company Established in the Year 2020. Since its inception, it has ushered the growth of the power technology industry in India. TriStar Engineers and Services is one of the key Industrial and I.T leaders, and its capability as a technology integrator has established it as a fore-runner in the market of today.</p>
            <p>As an acknowledged player in the power equipment industry, we have laid a foundation of prompt service support and reliability to all. We specialize in providing POWER SOLUTIONS and are a manufacturer of Online UPS with an excellent customer base.</p>
            <p>TriStar Engineers and Services is one of the fast-growing companies with the vision of providing their customers with an integrated energy solution adapting to the latest technological advances. We are an expert company that meets your electrical requirements, including project design, the supply of equipment, installation, repair, and maintenance.</p>
        </div>
        <div className="clients-container">
            <h2><strong>Our Clients</strong></h2>
            <div className="clients-grid">
                <div>
                    <h3>Banking Sector</h3>
                    <ul>
                        <li>Punjab National Bank</li>
                        <li>Bank of Baroda</li>
                        <li>Central Bank of India</li>
                        <li>Canara Bank</li>
                    </ul>
                </div>
                <div>
                    <h3>Glass Industries</h3>
                    <ul>
                        <li>Goyal Glass Industries</li>
                        <li>IB Glass Industries</li>
                        <li>KC Glass Industries</li>
                        <li>SR Glass Industries</li>
                        <li>Advance Glass Industries</li>
                        <li>Shri Balkishan Agrawal Glass Industries</li>
                    </ul>
                </div>
                <div>
                    <h3>Footwear Industry</h3>
                    <ul>
                        <li>Shanghavi Shoes</li>
                        <li>Eurosafety Footwear</li>
                        <li>Basant Overseas</li>
                    </ul>
                </div>
                <div>
                    <h3>Polymer & Plastic Industry</h3>
                    <ul>
                        <li>Bansal Polyplast</li>
                        <li>BS Polyplast</li>
                        <li>Konark Polytubes</li>
                        <li>Shri Giriraj Pipes</li>
                    </ul>
                </div>
            </div>
        </div>
        
        {/* <style>
            
        </style> */}
        
    </div>)
}

export default About;